import { EditRounded } from '@mui/icons-material';
import { Box, IconButton, Stack, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useDebounce } from 'react-use';

interface EditableCompareFilterFieldProps {
  initialFieldName: string;
  onChange: (fieldName: string) => void;
}

export const EditableCompareFieldName = ({
  initialFieldName,
  onChange,
}: EditableCompareFilterFieldProps) => {
  const [isEditFieldNameMode, setIsEditFieldNameMode] = useState(false);
  const [compareFieldName, setCompareFieldName] = useState(initialFieldName);

  useEffect(() => {
    setCompareFieldName(initialFieldName);
  }, [initialFieldName]);

  const closeAndUpdateFieldName = () => {
    setCompareFieldName(initialFieldName);
    setIsEditFieldNameMode(false);

    if (compareFieldName.trim() && compareFieldName !== initialFieldName) {
      onChange(compareFieldName);
    }
  };

  useDebounce(
    () => {
      if (compareFieldName.trim()) {
        onChange(compareFieldName);
      }
    },
    250,
    [compareFieldName],
  );

  if (!isEditFieldNameMode) {
    return (
      <Stack spacing={1} direction="row" alignItems="center">
        <Typography variant="body2">{initialFieldName}</Typography>
        <IconButton
          size="small"
          sx={{
            color: 'text.secondary',
          }}
          onClick={() => setIsEditFieldNameMode(true)}
          aria-label="edit-compare-field-name-button"
        >
          <EditRounded
            sx={{
              fontSize: (theme) => theme.typography.body1.fontSize,
            }}
          />
        </IconButton>
      </Stack>
    );
  }

  const onSubmit = (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    if (compareFieldName.trim()) {
      closeAndUpdateFieldName();
    }
  };

  return (
    <Box component="form" onSubmit={onSubmit} width="100%">
      <TextField
        autoFocus
        fullWidth
        onBlur={closeAndUpdateFieldName}
        size="small"
        value={compareFieldName}
        onChange={(e) => setCompareFieldName(e.target.value)}
        placeholder="Enter a name"
        required
      />
    </Box>
  );
};
